import { render, staticRenderFns } from "./AssessmentScreen.vue?vue&type=template&id=3ae76ada&"
import script from "./AssessmentScreen.vue?vue&type=script&lang=js&"
export * from "./AssessmentScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports